(function () {
  'use strict';

  function bootProductExperience() {
    var experience = document.querySelector('[data-rc-product-experience]');
    if (!experience || document.body.classList.contains('rc-px-active')) return;

    var journey = experience.dataset.journey || 'vault-object';
    var tier = experience.dataset.tier || 'entry';
    var form = experience.dataset.form || 'object';
    document.body.classList.add('rc-px-active', 'rc-px-' + journey, 'rc-px-tier-' + tier, 'rc-px-form-' + form);

    var details = document.querySelector('.product-information .product-details');
    var price = details && (details.querySelector('product-price') || details.querySelector('.price'));
    var noteTemplate = experience.querySelector('[data-rc-px-buying-note]');
    if (details && noteTemplate && !details.querySelector('.rc-px-buying-note')) {
      var note = noteTemplate.content.firstElementChild.cloneNode(true);
      if (price) price.insertAdjacentElement('afterend', note);
      else details.prepend(note);
    }

    var addButton = document.querySelector('.product-form-buttons button[name="add"]');
    var buyButton = document.querySelector('.product-form-buttons .shopify-payment-button__button');
    var contactLinks = Array.prototype.slice.call(document.querySelectorAll('.product-details a.button-custom'));
    var video = contactLinks.find(function (link) { return /video call/i.test(link.textContent); });
    var whatsapp = contactLinks.find(function (link) { return /whatsapp/i.test(link.textContent); });
    var addLabel = experience.dataset.addLabel || 'Add to bag';
    var buyLabel = experience.dataset.buyLabel || 'Buy it now';

    if (addButton) {
      addButton.classList.add('rc-px-action', 'rc-px-action--add');
      addButton.setAttribute('data-rc-px-label', addLabel);
      addButton.setAttribute('aria-label', addLabel);
    }
    if (buyButton) {
      buyButton.classList.add('rc-px-action', 'rc-px-action--buy');
      buyButton.textContent = buyLabel;
      buyButton.setAttribute('aria-label', buyLabel);
    }
    if (video) {
      video.classList.add('rc-px-action', 'rc-px-action--video');
      video.textContent = experience.dataset.videoLabel || 'See it on video';
    }
    if (whatsapp) {
      whatsapp.classList.add('rc-px-action', 'rc-px-action--whatsapp');
      whatsapp.textContent = experience.dataset.whatsappLabel || 'Ask RareCut';
    }
    if (video && whatsapp && video.parentElement === whatsapp.parentElement) {
      video.parentElement.classList.add('rc-px-contact-actions');
    }

    function labelStickyPurchaseActions(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll('.sticky-add-to-cart__button'), function (button) {
        if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', addLabel);
        if (!button.getAttribute('title')) button.setAttribute('title', addLabel);
      });
    }
    labelStickyPurchaseActions(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('.sticky-add-to-cart__button')) labelStickyPurchaseActions(node.parentElement || document);
          else labelStickyPurchaseActions(node);
        });
      });
    }).observe(document.body, { childList:true, subtree:true });

    /* Ring size is supplied by Product Customizer Plus in a separate
       /cart/add form. Its native `required` attribute therefore does not
       validate Shopify's main product form, dynamic checkout button, or the
       theme's sticky quick-add bar. Gate every purchase route here and mirror
       the chosen size into the actual product forms. */
    function installRequiredRingSize() {
      var ringSize = Array.prototype.find.call(document.querySelectorAll('select'), function (select) {
        return String(select.name || '').toLowerCase() === 'properties[ring size]';
      });
      if (!ringSize) return false;

      document.body.classList.add('rc-ring-size-gated');
      ringSize.required = true;

      var promptId = 'rc-ring-size-prompt';
      var prompt = document.getElementById(promptId);
      if (!prompt) {
        prompt = document.createElement('div');
        prompt.id = promptId;
        prompt.className = 'rc-ring-size-prompt';
        prompt.setAttribute('role', 'status');
        prompt.setAttribute('aria-live', 'polite');
        prompt.innerHTML = '<strong>Choose your ring size to continue.</strong><span>This piece cannot be added until a size is selected.</span>';
        var optionBlock = ringSize.closest('.product-customizer-option');
        (optionBlock || ringSize).insertAdjacentElement('afterend', prompt);
      }
      ringSize.setAttribute('aria-describedby', promptId);

      var actionSelector = [
        '.product-form-buttons button[name="add"]',
        '.product-form-buttons .shopify-payment-button__button',
        '.sticky-add-to-cart__button'
      ].join(',');

      function currentRingSize() {
        return String(ringSize.value || '').trim();
      }

      function mirrorRingSize(value) {
        Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), function (form) {
          if (form.contains(ringSize)) return;
          var hidden = form.querySelector('input[data-rc-ring-size-property]');
          if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'properties[Ring Size]';
            hidden.setAttribute('data-rc-ring-size-property', '');
            form.appendChild(hidden);
          }
          hidden.value = value;
          hidden.disabled = !value;
        });
      }

      function syncRingSizeGate() {
        var value = currentRingSize();
        var valid = value.length > 0;
        document.body.classList.toggle('rc-ring-size-pending', !valid);
        document.body.classList.toggle('rc-ring-size-complete', valid);
        prompt.classList.toggle('rc-ring-size-prompt--complete', valid);
        var promptState = valid ? 'complete:' + value : 'pending';
        if (prompt.dataset.rcRingPromptState !== promptState) {
          prompt.dataset.rcRingPromptState = promptState;
          prompt.innerHTML = valid
            ? '<strong>Ring size selected.</strong><span>' + value + ' will be added with this piece.</span>'
            : '<strong>Choose your ring size to continue.</strong><span>This piece cannot be added until a size is selected.</span>';
        }
        mirrorRingSize(value);

        /* Sticky/section-rendered product forms may clone the status node.
           Keep one live announcement and remove duplicate announcements from
           the accessibility tree without removing any visible UI. */
        Array.prototype.forEach.call(document.querySelectorAll('.rc-ring-size-prompt'), function (candidate) {
          if (candidate === prompt) return;
          candidate.setAttribute('aria-hidden', 'true');
          candidate.removeAttribute('aria-live');
          candidate.removeAttribute('role');
        });

        Array.prototype.forEach.call(document.querySelectorAll(actionSelector), function (button) {
          var label = String(button.textContent || button.getAttribute('aria-label') || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
          var soldOut = /sold out|unavailable/.test(label);
          button.dataset.rcRingBaseDisabled = soldOut ? 'true' : 'false';
          button.toggleAttribute('data-rc-ring-size-locked', !valid);
          if (!valid) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            button.setAttribute('aria-describedby', promptId);
            button.setAttribute('title', 'Choose your ring size first');
          } else {
            button.disabled = soldOut;
            if (!button.disabled) button.removeAttribute('aria-disabled');
            else button.setAttribute('aria-disabled', 'true');
            button.removeAttribute('aria-describedby');
            if (button.getAttribute('title') === 'Choose your ring size first') button.removeAttribute('title');
          }
        });
      }

      if (!ringSize.dataset.rcRingSizeGateBound) {
        ringSize.dataset.rcRingSizeGateBound = 'true';
        ringSize.addEventListener('change', syncRingSizeGate);
        ringSize.addEventListener('input', syncRingSizeGate);
      }

      if (!document.body.dataset.rcRingGateListeners) {
        document.body.dataset.rcRingGateListeners = 'true';

        document.addEventListener('click', function (event) {
          var action = event.target.closest && event.target.closest(actionSelector);
          if (!action) return;
          var selectedSize = currentRingSize();
          if (selectedSize && action.matches('.sticky-add-to-cart__button')) {
            var canonicalAdd = document.querySelector('.product-form-buttons button[name="add"]');
            if (canonicalAdd && !canonicalAdd.disabled) {
              event.preventDefault();
              event.stopImmediatePropagation();
              canonicalAdd.click();
            }
            return;
          }
          if (selectedSize) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          prompt.classList.remove('rc-ring-size-prompt--attention');
          void prompt.offsetWidth;
          prompt.classList.add('rc-ring-size-prompt--attention');
          ringSize.focus({ preventScroll: true });
          ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);

        document.addEventListener('submit', function (event) {
          var formTarget = event.target;
          if (!formTarget || !formTarget.matches('form[action*="/cart/add"]') || currentRingSize()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          prompt.classList.add('rc-ring-size-prompt--attention');
          ringSize.focus({ preventScroll: true });
          ringSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);

        new MutationObserver(function () {
          syncRingSizeGate();
        }).observe(document.body, { childList: true, subtree: true });
      }

      syncRingSizeGate();
      return true;
    }

    if (!installRequiredRingSize()) {
      var ringSizeObserver = new MutationObserver(function () {
        if (!installRequiredRingSize()) return;
        ringSizeObserver.disconnect();
      });
      ringSizeObserver.observe(document.body, { childList: true, subtree: true });
    }

    /* Shopify defers product videos behind a poster even when the video itself
       carries autoplay. Load only visible/near-visible media, then keep it
       muted and inline so mobile browsers permit playback. */
    function prepareProductVideo(mediaVideo) {
      if (!mediaVideo || mediaVideo.dataset.rcPxAutoplay === 'ready') return;
      mediaVideo.dataset.rcPxAutoplay = 'ready';
      mediaVideo.autoplay = true;
      mediaVideo.loop = true;
      mediaVideo.muted = true;
      mediaVideo.defaultMuted = true;
      mediaVideo.playsInline = true;
      mediaVideo.setAttribute('autoplay', '');
      mediaVideo.setAttribute('loop', '');
      mediaVideo.setAttribute('muted', '');
      mediaVideo.setAttribute('playsinline', '');
      mediaVideo.removeAttribute('controls');
      var playAttempt = mediaVideo.play();
      if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
    }

    function activateDeferredVideo(deferred) {
      if (!deferred || deferred.dataset.rcPxActivated === 'true') return;
      deferred.dataset.rcPxActivated = 'true';
      var poster = deferred.querySelector('.deferred-media__poster-button');
      if (poster) poster.click();
      deferred.classList.add('rc-px-video-loaded');
      window.setTimeout(function () {
        Array.prototype.forEach.call(deferred.querySelectorAll('video'), prepareProductVideo);
      }, 60);
    }

    var productMedia = document.querySelector('.product-information__media');
    if (productMedia) {
      var videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activateDeferredVideo(entry.target);
          videoObserver.unobserve(entry.target);
        });
      }, { rootMargin: '360px 0px', threshold: 0.01 }) : null;

      Array.prototype.forEach.call(productMedia.querySelectorAll('deferred-media'), function (deferred) {
        if (videoObserver) videoObserver.observe(deferred);
        else activateDeferredVideo(deferred);
      });
      Array.prototype.forEach.call(productMedia.querySelectorAll('video'), prepareProductVideo);

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches('video')) prepareProductVideo(node);
            Array.prototype.forEach.call(node.querySelectorAll ? node.querySelectorAll('video') : [], prepareProductVideo);
          });
        });
      }).observe(productMedia, { childList:true, subtree:true });
    }

    var magnetic = Array.prototype.slice.call(document.querySelectorAll('.rc-px-action'));
    var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (fine && !reduced) {
      magnetic.forEach(function (button) {
        button.addEventListener('pointermove', function (event) {
          var rect = button.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / Math.max(1, rect.width) - 0.5) * 8;
          var y = ((event.clientY - rect.top) / Math.max(1, rect.height) - 0.5) * 5;
          button.style.setProperty('--px-btn-x', x.toFixed(2) + 'px');
          button.style.setProperty('--px-btn-y', y.toFixed(2) + 'px');
        }, { passive: true });
        button.addEventListener('pointerleave', function () {
          button.style.setProperty('--px-btn-x', '0px');
          button.style.setProperty('--px-btn-y', '0px');
        }, { passive: true });
      });

      var fields = Array.prototype.slice.call(document.querySelectorAll('.product-information__media, [data-rc-px-media]'));
      fields.forEach(function (field) {
        field.addEventListener('pointermove', function (event) {
          var rect = field.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / Math.max(1, rect.width) - 0.5) * 2;
          var y = ((event.clientY - rect.top) / Math.max(1, rect.height) - 0.5) * 2;
          field.style.setProperty('--px-x', x.toFixed(3));
          field.style.setProperty('--px-y', y.toFixed(3));
          field.style.setProperty('--px-shift-x', (x * 7).toFixed(2) + 'px');
          field.style.setProperty('--px-shift-y', (y * 5).toFixed(2) + 'px');
          field.style.setProperty('--px-tilt-x', (y * -1.15).toFixed(3) + 'deg');
          field.style.setProperty('--px-tilt-y', (x * 1.4).toFixed(3) + 'deg');
        }, { passive: true });
        field.addEventListener('pointerleave', function () {
          field.style.setProperty('--px-shift-x', '0px');
          field.style.setProperty('--px-shift-y', '0px');
          field.style.setProperty('--px-tilt-x', '0deg');
          field.style.setProperty('--px-tilt-y', '0deg');
        }, { passive: true });
      });
    }

    var revealNodes = Array.prototype.slice.call(document.querySelectorAll('[data-rc-px-reveal]'));
    if (reduced || !('IntersectionObserver' in window)) {
      revealNodes.forEach(function (node) { node.classList.add('rc-px-in'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('rc-px-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      revealNodes.forEach(function (node) { observer.observe(node); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootProductExperience, { once: true });
  else bootProductExperience();
})();
